
import React from "react";

const ModalFooter = ({ primary = "Save", secondary = "Close", secondaryAttrs = {} }) => (
  <div className="modal-footer">
    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" {...secondaryAttrs}>
      {secondary}
    </button>
    <button type="submit" className="btn btn-primary" data-bs-dismiss="modal">
      {primary}
    </button>
  </div>
);

export default ModalFooter;
